import { Pipe, PipeTransform } from "@angular/core";

/**
 * Converts plain text with URLs into HTML with clickable links.
 * Escapes non-URL text to prevent XSS. Use with cSanitizeHtml and [innerHTML].
 */
@Pipe({
  name: "cLinkify",
})
export class CLinkifyPipe implements PipeTransform {
  private static escapeHtml(text: string): string {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  private static escapeAttr(url: string): string {
    return url
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  /** Match http:// or https:// URLs (stops at whitespace or common punctuation that isn't part of URL) */
  private static readonly URL_REGEX = /(https?:\/\/[^\s<>"']+)/g;

  transform(value: string | null | undefined): string {
    if (value == null || value === "") {
      return "";
    }
    const parts = value.split(CLinkifyPipe.URL_REGEX);
    return parts
      .map(part => {
        if (/^https?:\/\//.test(part)) {
          const url = part.trim();
          const href = CLinkifyPipe.escapeAttr(url);
          const text = CLinkifyPipe.escapeHtml(url);
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
        }
        return CLinkifyPipe.escapeHtml(part);
      })
      .join("");
  }
}
